// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------  resets  ------- */
html, body { height: 100%; background: #fff; margin: 0; padding: 0; }
article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section { display: block; }
textarea { resize: none }

/* -------  body  ------- */
body {
  min-width: 320px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #383e4b;
  transition: opacity 0.33s 0.33s cubic-bezier(0.075, 0.82, 0.165, 1);
  text-rendering: optimizeLegibility;
  -webkit-tap-highlight-color:  rgba(0,0,0,0);
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
}

#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

@page {
  size: auto;
}

a {
  text-decoration: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/styles/overrides/css-resetter.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B,aAAa,YAAY,EAAE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AACpE,gGAAgG,cAAc,EAAE;AAChH,WAAW,aAAa;;AAExB,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mEAAmE;EACnE,kCAAkC;EAClC,2CAA2C;EAC3C;uCACqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* -------  resets  ------- */\nhtml, body { height: 100%; background: #fff; margin: 0; padding: 0; }\narticle, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section { display: block; }\ntextarea { resize: none }\n\n/* -------  body  ------- */\nbody {\n  min-width: 320px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  color: #383e4b;\n  transition: opacity 0.33s 0.33s cubic-bezier(0.075, 0.82, 0.165, 1);\n  text-rendering: optimizeLegibility;\n  -webkit-tap-highlight-color:  rgba(0,0,0,0);\n  /* -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; */\n}\n\n#app {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n@page {\n  size: auto;\n}\n\na {\n  text-decoration: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
